import React, { ReactNode } from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function EventTasksToggleWrapper(
  props: {
    children: ReactNode,
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.EVENT_TASKS}>
      {props.children}
    </ToggleWrapper>
  )
}
